import angular from 'angular';
import { columnizedComponent } from './columnizedComponent';
import 'components/sharpr/image/imageModule';

angular.module('sh.columnized', ['sh.image', 'sh.imageSizer']).component('shColumnized', columnizedComponent());
